module.exports = __webpack_public_path__ + "4d13254ddb217b6b60785a6ea374215a.pdf";